import React, { useState } from "react";
import moment from "moment";
import useInterval from "use-interval";

export const Clock = () => {
  const now = moment().format("h:mm")
  const [time, setTime] = useState(now);

  useInterval(() => {
    setTime(moment().format("h:mm"));
  }, 1000);
  return (
    <>
      <section className="clock-wrapper">
        <h4 className="clock">{time}</h4>
      </section>
    </>
  )
};
